// List of framer-motion props that should NOT hit the DOM:
const motionPropNames = new Set([
  "initial","animate","transition","variants",
  "whileHover","whileTap","whileFocus","whileDrag","whileInView",
  "exit","layout","layoutId",
  "drag","dragConstraints","dragElastic","dragMomentum",
  "onAnimationStart","onAnimationComplete",
  "onHoverStart","onHoverEnd",
  "onTap","onTapStart","onTapCancel",
  "onDrag","onDragStart","onDragEnd",
  "onViewportEnter","onViewportLeave",
]);

export function shouldForwardMotionProp(prop) {
  return !motionPropNames.has(prop);
}
